import React, { useState } from 'react';

import Tooltip from 'components/tooltip';

interface copyOverlayProps {
  children: React.ReactNode,
  className?: string,
  dark?: boolean,
  successTooltip?: string,
  text: string,
  tooltip?: string,
}

export default function CopyOverlay({
  children,
  className,
  dark,
  successTooltip = 'Copied!',
  text,
  tooltip = 'Copy to clipboard',
}: copyOverlayProps) {
  const [overlayTooltip, setOverlayTooltip] = useState<string>(tooltip);

  function copy(event) {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard.writeText(text);
    setOverlayTooltip(successTooltip);
  }

  function reset() {
    setOverlayTooltip(tooltip);
  }

  return (
    <Tooltip content={overlayTooltip} dark={dark} shouldUpdatePosition>
      <div className={className} onClick={copy} onMouseEnter={reset}>
        {children}
      </div>
    </Tooltip>
  );
}
